import {
  HomeSection,
  Wrapper,
  SmallText,
  ButtonGroup,
  SocialLinksWrapper,
  WavingEmoji,
  SvgImg,
} from './styles';
import Header from '../../shared/Header';
import LinkButton from '../../shared/LinkButton';
import LinkIconButton from '../../shared/LinkIconButton';
import { useThemeContext } from '../../context/theme';
import socialLinks, { emailLink } from '../../data/socialLinks';
// import ResumePdf from '../../assets/resume/resume.pdf';
import HomeLightSvg from '../../svg/home-light.svg';
import HomeDarkSvg from '../../svg/home-dark.svg';

const Home = () => {
  const { darkMode } = useThemeContext();

  return (
    <HomeSection id="home">
      <Wrapper>
        <p>
          Hey there <WavingEmoji>👋</WavingEmoji>, my name is
        </p>
        <Header primary large>
          Amandeep Singh.
        </Header>
        <Header>I make cool stuff for the web.</Header>
        <SmallText>
          I'm a software engineer from India, currently specialising in
          development of web SPAs with React.js, REST/GraphQL APIs in Node.js,
          and other web technologies.
        </SmallText>
        <ButtonGroup>
          <LinkButton primary marginRight icon href={emailLink.url}>
            Email Me
          </LinkButton>
          <LinkButton icon href={socialLinks[0].url} target="_blank">
            Visit My GitHub Profile
          </LinkButton>
          {/* <LinkButton icon href={ResumePdf} target="_blank">
            Resume
          </LinkButton> */}
        </ButtonGroup>
        <SocialLinksWrapper>
          {socialLinks
            .filter((link) => link.site !== 'GitHub')
            .map((s) => (
              <LinkIconButton key={s.id} href={s.url} target="_blank">
                {s.icon}
              </LinkIconButton>
            ))}
        </SocialLinksWrapper>
      </Wrapper>
      <SvgImg src={darkMode ? HomeDarkSvg : HomeLightSvg} alt="home-svg" />
    </HomeSection>
  );
};

export default Home;
